module.exports = __webpack_public_path__ + "img/Z85-X18-中_13.2365d1c9.jpg";